import { useModalStore } from "@store/modal/modal";
import { ConfirmationModal } from "./ConfirmationModal";
import type { IConfirmationModalProps } from "./types";

export const useConfirmationModal = () => {
  const { create } = useModalStore();

  const openConfirmationModal = (options: IConfirmationModalProps) => {
    create((modalProps) => <ConfirmationModal {...options} {...modalProps} />);
  };

  return { openConfirmationModal };
};
